// @mui
import { styled } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
// hooks
import useLocales from '../../hooks/useLocales';
// components
import Page from '../../components-custom/Page';
// sections
import MobileVerificationForm from '../../sections/auth/MobileVerificationForm';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function MobileVerification() {
  const { translate } = useLocales();

  return (
    <Page title={translate('pageTitle', { page: translate('auth.mobileVerification.pageName') })} sx={{ height: 1 }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, mx: 'auto', textAlign: 'center' }}>
            <Typography variant="h3" paragraph>
              {translate('auth.mobileVerification.title')}
            </Typography>
            <Typography sx={{ color: 'text.secondary', mb: 5 }}>
              {translate('auth.mobileVerification.subtitle')}
            </Typography>

            <MobileVerificationForm />
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}
